<template>
  <div class="card-box">
    <slot></slot>
    <div class="btn-box">
      <div
        class="del-btn"
        v-if="del_Btn.show"
        @click.stop="$emit('handleDelete')"
      >
        <span>{{ del_Btn.value || "删除" }}</span>
      </div>
      <div
        class="mark-read-btn"
        v-if="btnList.includes('isRead')"
        @click.stop="$emit('handleRead')"
      >
        <span>标记已读</span>
      </div>
      <div
        class="mark-unread-btn"
        v-if="btnList.includes('unRead')"
        @click.stop="$emit('handleRead')"
      >
        <span>标记未读</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardBox",
  props: {
    btnList: {
      type: Array,
      default: (_) => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    del_Btn() {
      let del = { show: false };
      this.btnList.forEach((item) => {
        if (typeof item == "string" && item == "del") {
          del.show = true;
        } else if (typeof item == "object" && item.type == "del") {
          del = { ...item, show: true };
        }
      });
      return del;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  background: white;
  border-radius: 12px;
  position: relative;
  box-sizing: border-box;

  .btn-box {
    position: absolute;
    right: -80px;
    bottom: 0;
    div {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      text-align: center;
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      user-select: none;
      font-size: 12px;
      cursor: pointer;
    }
    .del-btn {
      background-color: #e5e5e5;
      color: #999999;
    }
    .mark-read-btn {
      background-color: white;
      color: #2a63f3;
    }
    .mark-unread-btn {
      background-color: white;
      color: #333333;
    }
  }
}
</style>
